import { z } from "zod";
import { intl } from "LocaleWrapper";
import { AdminNavigationItem } from "view/admin/utils/admin.types";
import { NavigationUrlParameter, Permission } from "__generated__/enums";
import { ZodSchema } from "@validation/utils/schemaUtils";

export const adminLanguageEntrySchema = z.record(z.string(), z.string().min(1));

export type AdminLanguageEntrySchemaInput = z.input<typeof adminLanguageEntrySchema>;
export type AdminLanguageEntrySchemaOutput = z.output<typeof adminLanguageEntrySchema>;

export const adminLanguageSchema = z.object({
	id: z.number().nullable(),
	description: z.string().min(1).max(255),
	code: z.string().min(1).max(2),
	isApplicationLanguage: z.boolean(),
	linkedLanguage: ZodSchema.requiredField(z.object({
		id: z.number(),
		description: z.string(),
		code: z.string(),
	})),
});

export type AdminLanguageSchemaInput = z.input<typeof adminLanguageSchema>;
export type AdminLanguageSchemaOutput = z.output<typeof adminLanguageSchema>;

export const adminSupportCategorySchema = z.object({
	id: z.number().nullable(),
	name: z.string().min(1),
	sequenceNumber: z.number().nullable(),
});

export type AdminSupportCategorySchemaInput = z.input<typeof adminSupportCategorySchema>;
export type AdminSupportCategorySchemaOutput = z.output<typeof adminSupportCategorySchema>;

export const adminSupportEntrySchema = z.object({
	id: z.number().nullable(),
	category: ZodSchema.requiredField(z.object({
		id: z.number(),
		name: z.string(),
	})),
	question: z.string().min(1),
	answer: z.string().min(1),
	sequenceNumber: z.number().nullable(),
});

export type AdminSupportEntrySchemaInput = z.input<typeof adminSupportEntrySchema>;
export type AdminSupportEntrySchemaOutput = z.output<typeof adminSupportEntrySchema>;

export const adminSupportBulkImportSchema = z.object({
	json: z.string().min(1),
});

export type AdminSupportBulkImportSchemaInput = z.input<typeof adminSupportBulkImportSchema>;
export type AdminSupportBulkImportSchemaOutput = z.output<typeof adminSupportBulkImportSchema>;

export const adminNavigationItemSchema = z.object({
	uniqueId: z.string().optional(),
	children: z.array(z.custom<AdminNavigationItem>()).nullish().transform(v => v ?? []),
	languageKey: z.string().min(1),
	permissions: z.array(z.enum(Permission)).min(1, intl.formatMessage({ id: "ZOD_VALIDATION_REQUIRED" })),
	url: z.string().nullish().transform(v => v ?? null),
	parameter: z.enum(NavigationUrlParameter).nullish().transform(v => v ?? null),
	plugins: z.array(z.string()).nullish().transform(v => v ?? []),
	icon: z.string().nullish().transform(v => v ?? null),
});

export type AdminNavigationItemInput = z.input<typeof adminNavigationItemSchema>;
export type AdminNavigationItemOutput = z.output<typeof adminNavigationItemSchema>;
